/**
 * Custom Nostr event kind constants for Cashero.
 */

/** Addressable kind for mint announcement (d-tag: "cashero-mint") */
export const MINT_ANNOUNCEMENT_KIND = 37691;

/** Regular kind for wallet→mint operation request (inner rumor, gift-wrapped) */
export const OP_REQUEST_KIND = 2293;

/** Regular kind for mint→wallet operation response (inner rumor, gift-wrapped) */
export const OP_RESPONSE_KIND = 2681;

/** Regular kind for spent proof event (NIP-44 encrypted content to mint) */
export const SPENT_PROOF_KIND = 5401;

/** The d-tag value for mint announcement events */
export const MINT_ANNOUNCEMENT_DTAG = 'cashero-mint';

/** The t-tag value for discovering Cashero mints */
export const MINT_DISCOVERY_TAG = 'cashero-mint';
